import { FC } from "react";
import PlaidIcon from "shared/icons/plaid.svg?react";
import { OnboardingData } from "../types";
import { Card } from "./Card";
import { Link } from "react-router-dom";

export const BillingView: FC<{ data: OnboardingData["billing"] }> = ({
  data
}) => {
  return (
    <div className="animate-appear mt-8 flex flex-col items-center justify-center">
      <p className="mb-2 text-center text-2xl font-bold text-content-1000">
        Connect payment method
      </p>
      <p className="mb-8 text-center text-sm font-medium text-content-300">
        Link your bank account
      </p>
      <div className="w-full px-4">
        <Card
          title="Connect with Plaid"
          icon={<PlaidIcon height={20} width={55} />}
          buttonText="Connect"
          onClick={() => window.open(data.plaid_link)}
        />
      </div>

      <Link
        to={data.ach_link}
        className="mt-2 text-base font-bold text-primary-500"
      >
        Link your bank account manually instead
      </Link>
    </div>
  );
};
